import { render, staticRenderFns } from "./DniFieldSimulation2.vue?vue&type=template&id=035f34d2&"
import script from "./DniFieldSimulation2.vue?vue&type=script&lang=ts&"
export * from "./DniFieldSimulation2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports